// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHDEgANQe8wz2lXNWiUvjT_hRUlsjgrIw",
  authDomain: "zenpipeline-1a6b1.firebaseapp.com",
  projectId: "zenpipeline-1a6b1",
  storageBucket: "zenpipeline-1a6b1.firebasestorage.app",
  messagingSenderId: "576899521511",
  appId: "1:576899521511:web:bfc1dc404297b7c469fb42",
  measurementId: "G-SWDYEDFKXR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
let analytics = null;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

// Initialize App Check with reCAPTCHA v3
// Site key is provided at build time via REACT_APP_RECAPTCHA_SITE_KEY
let appCheck = null;
if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
  // Only enable App Check in production (skip during local development)
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (!RECAPTCHA_SITE_KEY) {
    console.error("Missing REACT_APP_RECAPTCHA_SITE_KEY; App Check not initialized");
  } else {
    try {
      appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
        isTokenAutoRefreshEnabled: true
      });
      console.log("App Check enabled");
    } catch (error) {
      console.warn("App Check initialization failed:", error);
    }
  }
} else if (typeof window !== "undefined") {
  console.log("App Check disabled for local development");
}

// Initialize Cloud Functions
const functions = getFunctions(app, "us-central1");

// Connect to emulator in development
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_EMULATOR === "true") {
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.log("Connected to Functions emulator");
}

// Export initialized services
export { app, analytics, appCheck, functions };

// Export callable function references
export const createLeadFunction = httpsCallable(functions, "createLead");
